import ExportWorkflow from '../../../../components/workflows/general/export-workflow';


class ExportAll extends ExportWorkflow {
    constructor(Alert, $http, $uibModal, $translate) {
        super('rsvps', Alert, $http, $uibModal, $translate);
        this.key = `export-all-rsvps`;
        this.level = 'highlight';
        this.icon = 'upload';
        this.order = 40;
        this.title = 'Export all Guests';
    }

    action(payload, store) {
        store.commit('setSelectAll', true);
        super.action(payload, store).finally(() => {
            store.commit('setSelectAll', false);
        });
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('exportAllRsvps', [
        'Alert',
        '$http',
        '$uibModal',
        '$translate',
        (Alert, $http, $uibModal, $translate) => new ExportAll(Alert, $http, $uibModal, $translate)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/export-all-rsvps.js